/**
 * ID of the ECMWF CCP.
 */
export const ECMWF_CCP = 889;

/**
 * Default time steps.
 */
export const BASIC_SET = [72, 96, 120, 144, 168];

/**
 * Earliest time step which is considered "mid-range".
 */
export const MID_RANGE_START = 67;

/**
 * UI warning.
 */
export const NO_STEPS_WARNING =
	"You have not selected any steps. To meet our requirements, we have autoselected several steps to create a mid-range forecast. You can only unselect these steps if you select a range that goes beyond 12-66.";

/**
 * The set of allowed time-step factors in the UI's time-steps editor.
 */
export const DEFAULT_FACTORS = [1, 3, 6, 12, 24];

export const DYNAMIC_PAGE_MATCHER = "zaEZwRmwTV3f7ML";

/** Maximum number of points for a parameter time series product */
export const MAX_LOCATIONS = 500;

export const VOLUME_LIMIT_IN_MB = 100_000;
export const VOLUME_LIMIT = VOLUME_LIMIT_IN_MB * 1_000_000;
